import Glide from '@glidejs/glide'
import refs from '../helpers/refs'

class CFavoriteProductsSlider {
  constructor (el) {
    this.$el = el
    this.$refs = refs(this.$el)

    this.init()
  }

  init () {
    this.glideSlider = new Glide(this.$refs.slider, {
      bound: true,
      gap: 24,
      rewind: false,
      perView: 1,
      swipeThreshold: false,
      dragThreshold: false
    }).mount()
  }
}

// Wait for images to load in
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-c-favorite-products-slider]')
    .forEach(el => new CFavoriteProductsSlider(el))
})
